import { render, staticRenderFns } from "./PromotionBannerSetsForm.vue?vue&type=template&id=533c6f22&scoped=true&"
import script from "./PromotionBannerSetsForm.vue?vue&type=script&lang=js&"
export * from "./PromotionBannerSetsForm.vue?vue&type=script&lang=js&"
import style0 from "./PromotionBannerSetsForm.vue?vue&type=style&index=0&id=533c6f22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533c6f22",
  null
  
)

export default component.exports